import { render, staticRenderFns } from "./ProductCustomization.vue?vue&type=template&id=0ab0f797&scoped=true&"
import script from "./ProductCustomization.vue?vue&type=script&lang=js&"
export * from "./ProductCustomization.vue?vue&type=script&lang=js&"
import style0 from "./ProductCustomization.vue?vue&type=style&index=0&id=0ab0f797&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab0f797",
  null
  
)

export default component.exports